<template>
    <div>
        <div class="mb-5">类目差异化敏感属性与体积配置</div>
        <div class="mb-5"><el-button type="primary" @click="addConfig">新增</el-button></div>
        <el-table :data="tableList" stripe style="width: 75%">
            <el-table-column prop="date" label="类目" align="center">
                <template slot-scope="{row,$index}">
                    <category-input ref="cinput" v-model="row.categoryIds" platform="pddtemu" :isShowSyncBtn="false" @change="(categoryIds, labels, lastLevelCateGory) => categoryChange($index,categoryIds, labels, lastLevelCateGory)" />
                </template>
            </el-table-column>
            <el-table-column prop="date" label="敏感属性" align="center" width="250">
                <template slot-scope="{row}">
                    <SensitiveAttrInput v-model="row.skuWhExtAttr.attrObj" />
                </template>
            </el-table-column>
            <el-table-column prop="date" label="体积(cm)" align="center" width="180">
                <template slot-scope="{row}">
                    <VolumeInput v-model="row.skuWhExtAttr.productSkuVolumeReq" />
                </template>
            </el-table-column>
            <el-table-column prop="date" label="重量" align="center" width="150">
                <template slot-scope="{ row }">
                    <el-input-digit
                        v-model.number="row.skuWhExtAttr.productSkuWeightReq.weightValue"
                        placeholder="请输入"
                        format="#.#"
                        style="width: 90px"
                    >
                        <span>g</span>
                    </el-input-digit>
                </template>
            </el-table-column>
            <el-table-column prop="date" label="操作" width="100" align="center">
                <template slot-scope='{row,$index}'>
                    <el-link type="danger" @click="delRow($index)">删除</el-link>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import { merge } from 'lodash';
import CategoryInput from '@/components/prod/center/components/PlatformCategoryInput/index.vue'
import SensitiveAttrInput from '@/components/prod/center/components/TemuInfoForm/components/FormItemSkuListExtends/SensitiveAttrInput.vue'
import VolumeInput from '@/components/prod/center/components/TemuInfoForm/components/FormItemSkuListExtends/VolumeInput.vue'
import constantConfigs from '@/components/prod/center/components/TemuInfoForm/config.js'

const dialogConfig = () => {
    return {
        categoryId:'',
        categoryIds:[],
        skuWhExtAttr:{
            attrObj:{
                productSkuSensitiveAttrReq:{
                    isSensitive:0,
                    sensitiveTypes:[],
                },
                productSkuSensitiveLimitReq:{
                    maxBatteryCapacity: '',
                    maxLiquidCapacity: '',
                    maxKnifeLength: '',
                    knifeTipAngle: { degrees: '' }
                },
            },
            productSkuVolumeReq:{
                volumeHeight:'',
                volumeLen:'',
                volumeWidth:''
            },
            productSkuWeightReq:{
                weightValue: '', // 重量值，单位g
            },
        }
    }
}
export default {
    model: {
        prop: 'value',
        event: 'change',
    },
    provide:{
        elFormItem:null,
    },
    components: {
        CategoryInput,
        SensitiveAttrInput,
        VolumeInput,
    },
    props:{
        value:{
            type:Array,
            default(){
                return []
            }
        },
        shopList:{
            type:Array,
            default(){
                return []
            }
        }
    },
    data(){
        return {
            ...constantConfigs,
            tableList:[],
            isInitData:false,
        }
    },
    watch:{
        value:{
            handler(v){
                if(!this.isInitData){
                    this.initData()
                }
            },
            deep:true
        },
        tableList:{
            handler(v){
                let list = v.map(item => {
                    let { skuWhExtAttr,...reset } = item
                    const { attrObj,...reset2 } = skuWhExtAttr
                    skuWhExtAttr = {
                        ...reset2,
                        ...attrObj,
                    }
                    let obj = {
                        ...reset,
                        skuWhExtAttr
                    }
                    return obj
                });
                this.$emit('change',list)
            },
            deep:true,
        }
    },
    methods:{
        initData(){
            this.isInitData = true
            let dafaultCfg = dialogConfig()
            let list = this.value.map(item => {
                const { skuWhExtAttr,...reset } = item
                let { productSkuSensitiveAttrReq,productSkuSensitiveLimitReq,productSkuWeightReq,...subreset } = skuWhExtAttr;
                let obj = {
                    ...reset,
                    skuWhExtAttr:{
                        attrObj:{
                            productSkuSensitiveAttrReq,
                            productSkuSensitiveLimitReq,
                        },
                        productSkuWeightReq: productSkuWeightReq || dafaultCfg.skuWhExtAttr.productSkuWeightReq,
                        ...subreset
                    }
                }
                return obj
            });
            this.tableList = list
        },
        categoryChange(index,categoryIds, labels, lastLevelCateGory) {
            this.$set(this.tableList[index],'categoryId',lastLevelCateGory.cid)
        },
        addConfig(){
            this.tableList.push(dialogConfig())
        },
        delRow(index){
            this.tableList.splice(index,1)

        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-button{
    height: 24px !important;
}
.red{
    color: #f56c6c;
}
</style>
